<template>
    <v-dialog v-model="visible" class="w-75" @after-enter="onOpened">
        <v-card height="75vh">
            <v-card-title class="pa-5">{{ $t('dialog.manualExecutionHistory') }}</v-card-title>

            <v-divider />

            <AgGrid class="flex-grow-1" ref="manualExecutionHistoryAgGridRef" :fetchUrl="manualExecutionHistoryFetchUrl" :columnDefs="manualExecutionHistoryColumnDefs"
            :gridParams="manualExecutionHistoryGridParams" :refresh="manualExecutionHistoryRefresh" domLayout="normal" :refreshCallback="manualExecutionCallback"/>

            <v-divider />

            <v-card-actions class="justify-end">
                <v-btn variant="text" color="error" @click="visible = false">{{ $t('action.cancel') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
    import { inject, ref, useTemplateRef } from 'vue';
    import AgGrid from '@/components/AgGrid.vue';
    import { toast } from 'vue3-toastify';
    import { useLogStore } from '@/stores/logStore';
    import { useUserStore } from '@/stores/userStore';

    const emit = defineEmits(['execution-launched']);

    const urlWebAPI = inject('urlWebAPI');
    const translate = inject('translate');

    const logStore = useLogStore();
    const userStore = useUserStore();

    const visible = ref(false);

    const manualExecutionHistoryGridRef = useTemplateRef('manualExecutionHistoryAgGridRef');
    const manualExecutionHistoryFetchUrl = 'GetManualExecutionHistory';
    const manualExecutionHistoryColumnDefs = [
        {
            field: 'createdDate',
            sort: 'desc',
            type: 'date',
            headerName: translate('createdDate', 'column'),
        },
        {
            field: 'user',
            sort: 'asc',
            headerName: translate('user', 'column'),
        },
        {
            field: 'reference',
            headerName: translate('reference', 'column'),
        },
        {
            field: 'actionGroup',
            headerName: translate('actionGroup', 'column'),
        },
        {
            field: 'parameters',
            headerName: translate('parameters', 'column'),
            minWidth: 400,
        },
        {
            field: 'restart',
            headerName: translate('restart', 'column'),
            type: 'restartAction',
        },
    ];
    const manualExecutionHistoryGridParams = {
        token: userStore.getUser().token,
        distributorId: userStore.getUser().distributorId,
        customerReference: null,
    };

    const manualExecutionHistoryRefresh = ref(false);

    function open() {
        visible.value = true;
    }

    function onOpened() {
        triggerRefresh();
    }

    function triggerRefresh() {
        manualExecutionHistoryGridRef.value.gridRef.api.setGridOption("loading", true);
        manualExecutionHistoryRefresh.value = true;
    }

    function onCellClicked(params) {
        if (typeof params.data != 'undefined' && typeof params.colDef.field != 'undefined' && params.colDef.field == 'restart')
            restartManualExecution(params).then(() => {
                visible.value = false;
            });
    }

    function manualExecutionCallback(){
        manualExecutionHistoryRefresh.value = false;
        manualExecutionHistoryGridRef.value.gridRef.api.setGridOption("loading", false);
    }

    function restartManualExecution(params) {
        let data = {
            action: 'ManualExecution',
            reference: params.data.reference,
            actionGroup: params.data.actionGroup,
            parameters: params.data.parameters,
        };

        return $.getData(urlWebAPI + 'ProcessActivator', data)
            .then((logs) => {
                emit('execution-launched', data);
            })
            .catch(error => {
                logStore.log(error, 'error');
                toast.error('Error during executing ProcessActivator.');
            });
    }

    defineExpose({ open, triggerRefresh, onCellClicked });
</script>
